import type { ArtistFiltersType } from './types';

export const DEFAULT_ARTIST_FILTERS: ArtistFiltersType = {
  labels: [],
  isCrossover: false,
  isOnRoster: undefined,
};

export const SELECTED_TAG_CLASSES =
  'bg-default-inverse/full text-strong-on-light hover:bg-default-inverse/full hover:outline-hover focus:bg-default-inverse/full focus:outline-hover';
